import {
  multi,
  OTHER,
  option,
  single,
  text,
  type UsFieldDef,
  type UsWorksheetDefinition,
} from "../us-fields";

const vein = (id: string, heading: string): UsFieldDef[] => [
  single(
    `dvt.${id}_compressibility`,
    "Compressibility",
    [
      option("compressible", "Compressible"),
      option("non_compressible", "Non-compressible"),
    ],
    { normal: "compressible", heading },
  ),
  single(
    `dvt.${id}_thrombus`,
    "Thrombus",
    [
      option("absent", "Thrombus absent"),
      option("present", "Thrombus present"),
    ],
    { normal: "absent" },
  ),
];

export const US_DVT: UsWorksheetDefinition = {
  examType: "us_dvt",
  version: 1,
  indications: [
    option("right_leg_pain_swelling", "Right Leg pain/swelling"),
    option("left_leg_pain_swelling", "Leg swelling/swelling"),
    option("pulmonary_embolism", "Pulmonary embolism"),
  ],
  otherIndication: true,
  sections: [
    {
      id: "dvt_leg",
      label: "leg",
      role: "findings",
      technicallyLimited: true,
      technicallyLimitedReason: "dvt.technically_limited_reason",
      repeatPerSide: ["right", "left"],
      fields: [
        ...vein("common_femoral", "Common femoral vein"),
        ...vein("saphenofemoral", "Saphenofemoral junction"),
        ...vein("femoral", "Femoral Vein"),
        ...vein("popliteal", "Popliteal vein/trifurcation"),
        text("dvt.other_findings", "Other Findings"),
      ],
    },
    {
      id: "dvt_impression",
      label: "Impression",
      role: "impression",
      fields: [
        multi("dvt.impression", "Impression", [
          option("dvt_absent", "DVT absent"),
          option("dvt_present", "DVT present on", { sided: true }),
          option("indeterminate", "Indeterminate"),
          OTHER,
        ]),
      ],
    },
  ],
  normalImpressions: [{ sectionId: "dvt_impression", value: "dvt_absent" }],
  billing: {
    codes: [
      {
        cpt: "93971",
        label: "DVT ultrasound, limited (unilateral or bilateral)",
        preTick: true,
      },
    ],
  },
};
